import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';

@Component({
  selector: 'app-cropper-dialog',
  standalone: false,
  templateUrl: './cropper-dialog.component.html'
})
export class CropperDialogComponent {
  @Input() image!: File;
  @Input() ratio!: number;

  result!: any;
  showCropper = false;
  scale = 1;
  transform: ImageTransform = {
    translateUnit: 'px'
  };

  constructor(public modal: NgbActiveModal) { }

  imageLoaded() {
    this.showCropper = true;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.result = event;
  }

  zoomOut() {
    if (this.scale < .3) return
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  saveImage() {
    this.modal.close(this.result);
  }
}
